// DEPENDENCIES
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import { Link, browserHistory } from 'react-router';
import SVGInline from 'react-svg-inline';
import Scrollchor from 'react-scrollchor';

// INNER IMPORTS
import { SignupModalContainer } from '../Users/Signup';
import { LoginModalContainer } from '../Users/Login';
import ParticipateModal from '../Users/Participate';
import { SubmitModalContainer } from '../Users/Submit';
import { SubmitBandFinderModalContainer } from '../Users/SubmitBandFinderModal';
import { PayingMethods } from '../Modals/PayingMethods';

import { getUsernameFromToken, isMobile } from '../../utils';
import {
    createNotActivatedMessage,
    createActivatedMessage,
    createSuccessfulNewPaidPin,
    createSuccessfulUpdatedPaidPin
} from '../../Models/strings';

// actions
import * as actions from '../../Actions/main';
import * as userActions from '../../Actions/users';
import { toggleMobileSideMenu } from '../../Actions/ui';
import { closePinFullViewModal } from '../../Actions/modals';
import { setInfoMessageBar } from '../../Actions/messages';

// services
import { AnalyticsService } from "../../Services";

// modals
import { GeneralMessage } from '../Modals/GeneralMessage';
import { LoadingSpinner } from '../Modals/LoadingSpinner';
import { TempUserLogin } from '../Modals/TempUserLogin';

// consts
import { BAND, LIVE_MUSIC, MUSICIAN, SERVICE } from "../../consts";

// styles
import './TopBar.css';

// icons
import listingOptionsSVG from "../inlineSVGs/listingOptionsSVG";
import mapLocationSVG from "../inlineSVGs/mapLocationSVG";
import userOutlineSVG from "../inlineSVGs/userOutlineSVG";
import shadowMugicsSVG from '../inlineSVGs/shadowMugicsSVG';
import mainLogoSVG from '../inlineSVGs/mainLogoSVG';
import bandFinderNavSVG from '../inlineSVGs/bandFinderNavSVG';
import servicesNavSVG from '../inlineSVGs/servicesNavSVG';
import liveMusicNavSVG from '../inlineSVGs/liveMusicNavSVG';
import hamburgerSVG from "../inlineSVGs/hamburgerSVG";
import ParticipateMobileModal from "../Users/ParticipateMobile";

// user-panel?pin_id=6332ad54be772283f59395b0&redirect=slick&action=new&type=huge&verified=verified&Token=1ef6e49c-7f07-43c3-9e59-d4c54bcb3dcb&#b
const SMALL_SCREEN_WIDTH = 350;

class TopBar extends Component {
    // If the user changes the type (Services/Live music), the filters should change accordingly and reload the pins
    // We should remove previous category and subCategory as well
    constructor(props) {
        super(props);

        this.state = {
            isScrolledTop: true
        };

        this.handleScroll = this.handleScroll.bind(this);
        this.aboutRef = {};
    }

    componentDidMount() {
        // if (window.location.pathname.includes('packages')) return

        window.addEventListener('scroll', this.handleScroll);

        if (!window.location.hash || window.location.hash === '') {
            this.props.clearPinList();
        }

        // TODO: request ad from url params - check if ad is valid paid etc.
        // TODO: one time add pop up
        //if (this.props.token) this.props.userPinsCall(this.props.token);

        // TODO: check here if path contains pop up flags
        const urlQuery = new URLSearchParams(window.location.search)

        this.confirmPurchaseEvent(urlQuery);
        this.popupOnRedirect(urlQuery);
        this.handleDeepLinkPath();
        this.popUpOnStart();
        this.filterOnStart(urlQuery);
        this.paymentRedirect(urlQuery);
        this.scrollToAbout();
        this.handleConformationRedirect(urlQuery);

        // this.props.openSplashScreenModal();
        // window.addEventListener('load', this.appReady.bind(this));

        window.addEventListener('popstate', () => {
            this.closeAllModals()

        }, false);

        if (this.props.isVerified || window.location.pathname.includes('packages')) return;

        setTimeout(() => {
            this.props.getUserData();
        }, 500);

        // this.backListener = browserHistory.listen(loc => {
        //     if (loc.action === "POP") {
        //         // browserHistory.push(this.props.route);
        //         // close modals
        //         this.closeAllModals()
        //
        //     }
        // })
    }

    componentDidUpdate(prevProps) {
        if (!prevProps) return;
        // if (window.location.pathname.includes('packages')) return

        // Participate opened
        if (!prevProps.isParticipateModalOpen && this.props.isParticipateModalOpen) {
            disableBodyScroll(document.body);
        // Participate closed
        } else if(prevProps.isParticipateModalOpen && !this.props.isParticipateModalOpen) {
            clearAllBodyScrollLocks()
        }

        // only place getPinsCall should be called on rendering
        if (prevProps.filters) {
            if (
                prevProps.filters.type !== this.props.filters.type ||
                prevProps.filters.title !== this.props.filters.title ||
                prevProps.filters.category !== this.props.filters.category ||
                prevProps.filters.subCategory !== this.props.filters.subCategory ||
                prevProps.filters.lookingForType !== this.props.filters.lookingForType ||
                prevProps.filters.iWeAre !== this.props.filters.iWeAre ||
                this.isLocationNew(prevProps.filters.location, this.props.filters.location) ||
                // this.isDateNew(this.props.filters.type, prevProps.filters.begins, this.props.filters.begins) ||
                this.isDateNew(this.props.filters.type, prevProps.filters.ends, this.props.filters.ends)
            ) {
                this.props.clearPinList();
                this.props.clearCountryPinCount();

                this.props.getPinsCall(this.props.filters);

                this.props.getMapPinsCall(this.props.filters);
                this.props.getPinCountCall();

            } else if (this.isLocationNew(prevProps.filters.mapLocation, this.props.filters.mapLocation)) {
                // TODO: check if map in view
                this.props.getMapPinsCall(this.props.filters);
            }
            else if (prevProps.filters.pageNumber !== this.props.filters.pageNumber) {
                this.props.getPinsCall(this.props.filters);
            }
        }
    }

    isDateNew(type, prevDate, newDate) {
        if (type !== LIVE_MUSIC) return;

        if (!prevDate && newDate) return true;

        return !!(prevDate && newDate && !prevDate.isSame(newDate))
    }

    isLocationNew(prevLoc = {}, newLoc = {}) {
        if (!prevLoc && !newLoc) return;
        if (!prevLoc || !newLoc) return true;

        if (
            prevLoc.bottom !== newLoc.bottom ||
            prevLoc.top !== newLoc.top ||
            prevLoc.left !== newLoc.left ||
            prevLoc.right !== newLoc.right
        ) {
            return true;
        }
    }

    componentWillUnmount() {
        //super.componentWillUnmount();
        // Unbind listener
        //this.backListener();

        window.removeEventListener('scroll', this.handleScroll);

        //window.removeEventListener('load', this.appReady)
    }

    closeAllModals() {
        if (!this.props) return;

        this.props.closeSubmitModal();
        this.props.closeParticipateModal();
        this.props.closeSubmitBandFinderModal();
        this.props.closeSignupModal();
        this.props.closeLoginModal();
        this.props.closePinModal();
        this.props.closeBandFinderPinModal();
        this.props.closePinFullViewModal();
    }

    handleScroll() {
        if (window.scrollY < 1 && !this.state.isScrolledTop) {
            this.setState({ isScrolledTop: true });
        } else if (window.scrollY > 1 && this.state.isScrolledTop) {
            this.setState({ isScrolledTop: false})
        }
    }

    handleDeepLinkPath() {
        // ad id and pop up its pin
        // const query = new URLSearchParams(window.location.search);

        const pinID = window.location.hash && window.location.hash.replace('#&ad=', '');

        if (!pinID) return;

        this.props.getSharedPin(pinID);
    }

    getFormattedUsername(token) {
        const { userName } = getUsernameFromToken(token);

        let maxChars = 10;
        if (window.innerWidth < SMALL_SCREEN_WIDTH) {
            maxChars = 5;
        }
        return userName.length > maxChars ? userName.slice(0, maxChars) + '...' : userName;
    }

    loadUriType(type) {
        this.props.resetFiltersType(type);

        window.location = `/#${type}`;
        AnalyticsService.sendEvent(AnalyticsService.events.TOP_FILTER, type, null, { type });
    }

    changeUriType(value, query) {
        // if (isCatChange) this.props.clearPinList();

        if (!query) return this.props.addFilter('category', value)

        this.props.resetFiltersType(value);

        if (query.has('cat') || query.has('scat')) {
            this.props.updateFilters({
                category: query.get('cat') || this.props.filters.category,
                subCategory: query.get('scat') || this.props.filters.subCategory,
                pageNumber: 0,
                type: value
            });
        }

        // if (query.has('scat')) {
        //     this.props.addFilter('subCategory', query.get('scat'));
        // }

        // if on main page just change the filter value - see filterOnStart in this file
    }

    signOut() {
        this.props.signOut();
    }

    onParticipate() {
        AnalyticsService.sendEvent(AnalyticsService.events.PARTICIPATE_MAIN);

        browserHistory.push(this.props.route);
        browserHistory.push('/#')
        this.props.openParticipateModal();
    }

    onLogin() {
        browserHistory.push(this.props.route);
        browserHistory.push('/#');
        this.props.openLoginModal();
    }

    onSignup() {
        browserHistory.push(this.props.route);
        this.props.openSignupModal()
    }

    onSubmit(type) {
        AnalyticsService.sendEvent(AnalyticsService.events.OPEN_SUBMIT_MODAL, type, null, { type });

        this.props.openSubmitModalRequest(type)
    }

    confirmPurchaseEvent(query) {
        if (!query.has('action') || !query.has('type') || !query.has('verified')) return;

        //url example: action=new&type=huge&verified=verified
        const action = query.get('action');
        const planType = query.get('type');
        //const verifiedStat = query.get('verified');

        if (action !== 'new') return;

        AnalyticsService.sendEvent(AnalyticsService.events.PURCHASE, `ad_${planType}`, null, {
            plan_type: planType,
        })
    }

    popupOnRedirect(query) {
        if (query.has('action')) {
            const action = query.get('action');
            let message = {};

            if (action === 'new') {
                message = createSuccessfulNewPaidPin();
            }

            if (action === 'update') {
                message = createSuccessfulUpdatedPaidPin();
            }

            const isActivated = query.get('verified');

            if (!isActivated) {
                message = createNotActivatedMessage()
            }

            return this.props.openGeneralMessageModal(message.header, message.body);
        }

        if (!query.has('a')) return;

        try {
            const type = atob(query.get('t'));
            const isActivated = atob(query.get('a'));

            if (isActivated === 'false') {
                const message = createNotActivatedMessage(type);
                this.props.openGeneralMessageModal(message.header, message.body);

                return;
            }

            if (this.props.token) {
                browserHistory.replace('user-panel');
            }

            const message = createActivatedMessage();
            this.props.openGeneralMessageModal(message.header, message.body);

            if (!this.props.token) {
                browserHistory.push('/#')
                this.props.openLoginModal();
            }
        } catch(err) {
            return;
        }
    }

    popUpOnStart() {
        if (window.location.hash === '#login' && !this.props.token) {
            browserHistory.push('/#')
            return this.props.openLoginModal();
        }

        if (window.location.hash === '#signup' && !this.props.token) {
            browserHistory.push('/#')
            return this.props.openSignupModal();
        }

        if (window.location.hash === '#participate') {
            browserHistory.push('/#')
            return this.props.openParticipateModal();
        }

        if (window.location.hash === '#contact') {
            return this.props.openContactModal();
        }

        if (window.location.hash === '#promo-video') {
            return this.props.openVideoModal();
        }
    }

    filterOnStart(query) {
        // liveMusic is the default so no point on checkin it
        if (window.location.hash.includes('#liveMusic')) {
            return this.changeUriType(LIVE_MUSIC, query);
        }

        if (window.location.hash.includes('#service')) {
            return this.changeUriType(SERVICE, query);
        }

        if (window.location.hash.includes('#band')) {
            return this.changeUriType(BAND, query);
        }

        if (window.location.hash.includes('#musician')) {
            return this.changeUriType(MUSICIAN, query);
        }
    }

    categoryFilterOnStart() {

    }

    paymentRedirect(query) {
        if (!query.has('redirect') || query.get('redirect') !== 'slick') return;

        const action = query.get('action');
        const pinId = query.get('pin_id');
        const type = query.get('type');

        this.props.serverRedirect(pinId, action, type)
    }

    scrollToAbout() {
        if (window.location.hash !== '#about-main' || !this.aboutRef) return;

        setTimeout(() => {
            document.querySelector('#about').scrollIntoView({ behavior: 'smooth' });
        }, 1200);
    }

    handleConformationRedirect(query) {
        if (!query || !query.has('ci') || !query.has('ct')) return;

        const userId = query.get('ci');
        const activationToken = query.get('ct');

        this.props.userActivation(activationToken, userId);
    }

    handleVideoWatch() {
        this.props.openVideoModal();
        AnalyticsService.sendEvent(AnalyticsService.events.WATCH_VIDEO_NAV)
    }

    // render methods
    // not in use for now - moved to side menu
    renderMobileLogging() {
        if (this.props.isLoggedIn) {
            return (
                <div className="loging-mobile ">
                    <div className="username">
                        <Link to="/user-panel" onlyActiveOnIndex={false}>
                            {this.getFormattedUsername(this.props.token)}
                        </Link>
                    </div>
                    <div className="seperator">
                        |
                    </div>
                    <div className="signout" onClick={this.signOut.bind(this)}>
                        Sign out
                    </div>
                </div>
            )
        }
        return (
            <div className="loging-mobile not-logged" onClick={() => this.onLogin()}>
                <SVGInline svg={userOutlineSVG} component="i" width="25px" className="mugics-icon"/>

                <div className="login">
                    login
                </div>
            </div>
        )
    }

    // not in use for now - moved to side menu
    renderMobileMap() {
        return (
            <div className="map-list-mobile" onClick={() => this.props.toggleMode()}>
                {this.props.mode === 'map' ?
                    <SVGInline svg={listingOptionsSVG} className="toggle-map-icon" component="i"/>
                    :
                    <SVGInline svg={mapLocationSVG} className="toggle-map-icon" component="i"/>
                }
                <p>{this.props.mode === 'map' ? 'List' : 'Map'}</p>
            </div>
        )
    }

    // GO LIVE
    renderMobileGoLive() {
        return (
            <div className="participate-mobile" onClick={() => this.onParticipate()}>
                <div className="go-live-plus">+</div>
                <p>פרסם</p>
            </div>
        )
    }

    renderTitle() {
        return (
            <div className="mugics-title">
                {window.location && (window.location.pathname.includes('user-panel') || window.location.pathname.includes('packages')) ?
                    <Link href="/#header" onlyActiveOnIndex>
                        <SVGInline svg={mainLogoSVG} component="i"/>
                    </Link>
                    :
                    <Scrollchor to="#header">
                        <SVGInline svg={mainLogoSVG} component="i"/>
                    </Scrollchor>
                }
            </div>
        )
    }

    renderWebLogging() {
        if (this.props.isLoggedIn) {
            return (
                <div className="login-signup">
                    <SVGInline svg={shadowMugicsSVG} component="i" width="15px" className="mugics-icon"/>
                    <div className="username">
                        <Link to="/user-panel" onlyActiveOnIndex={false}>
                            {this.getFormattedUsername(this.props.token)}
                        </Link>
                    </div>
                    <div className="seperator">
                        |
                    </div>
                    <div className="signout" onClick={this.signOut.bind(this)}>
                        התנתקות
                    </div>
                </div>
            )
        }

        return (
            <div className="login-signup">
                {isMobile() ?
                    <div className="signUp" onClick={() => this.onSignup()}>
                        Sign Up
                    </div>
                    : null
                }
                {isMobile() ? <div className="seperator">|</div> : null}
                <div className={`login ${!isMobile() ? 'btn' : ''}`} onClick={() => this.onLogin()}>
                    התחברות
                </div>

            </div>
        );
    }

    renderTopNavBar() {
        if (!this.props.datatypes) return null;

        return this.props.datatypes.types.map((type, index) => {

            if (index > 2) return null;

            let convertedType = 'הופעות חיות';

            let isSelected = this.props.filters.type && this.props.filters.type === type.name;

            let typeIcon = liveMusicNavSVG;
            if (type.name === 'service') {
                convertedType = 'שירותי מויזיקה';
                typeIcon = servicesNavSVG;
            }

            if (type.name === 'band' || type.name === 'musician') {
                convertedType = 'יוצר להקות';
                typeIcon = bandFinderNavSVG;

                if (this.props.filters) {
                    isSelected = this.props.filters.type === 'band' || this.props.filters.type === 'musician';
                }
            }

            // <Scrollchor to="web-search-bar" key={index}>
            return (
                <div className={`nav-bar-cat-wrapper ${type.name}`} key={index}>
                    <SVGInline svg={typeIcon} component="i" className="mugics-icon"/>

                    <div
                        className={type.name + (isSelected ?
                            " selected" : " unselected") }
                        onClick={() => this.loadUriType(type.name)}>
                        {isSelected ? convertedType.toUpperCase() : convertedType}
                    </div>
                </div>
            )
        })
    }

    renderMobileView(mugicsType) {
        return (
            <div className="wrapper">
                <div className="header-wrapper-mobile rtl">

                    <div className={`hamburger ${mugicsType}`} onClick={() => this.props.toggleMobileSideMenu()}>
                        <SVGInline svg={hamburgerSVG} component="i" />
                    </div>
                    <div className="mugics-title">
                        <Link href="/#header" onlyActiveOnIndex>
                            <SVGInline svg={mainLogoSVG} component="i"/>
                        </Link>
                    </div>
                    {this.renderMobileGoLive()}
                </div>
            </div>
        )
    }

    renderWebView() {
        return (
            <div className="wrapper">
                <div className="leftContainer">
                    {this.renderTitle()}
                    {this.renderTopNavBar()}
                </div>

                <div className="rightContainer">
                    {/*<div className="contact-us-btn btn-web" onClick={() => this.props.openContactModal()}>*/}
                    {/*    Contact us*/}
                    {/*</div>*/}
                    {/*<div className="watch-video-btn btn-web" onClick={() => this.handleVideoWatch()}>*/}
                    {/*    1 min video*/}
                    {/*</div>*/}
                    <div ref={ ref => this.aboutRef = ref } id="about-main-web" className="about btn-web">
                        {window.location && window.location.pathname.includes('user-panel') ?
                            <Link href="/#about-main" onlyActiveOnIndex>עלינו</Link>
                            :
                            <Scrollchor to="#about">עלינו</Scrollchor>
                        }
                    </div>

                    {this.renderWebLogging()}

                    <div className="participate" onClick={() => this.onParticipate()}>פרסם!</div>
                </div>
            </div>
        )
    }

    render() {

        return (
            <div
                className={`topBar rtl ${this.state.isScrolledTop || this.props.route.includes('packages') ? 'scrolled-top' : ''} ${this.props.route.includes('packages') ? 'non-stick' : ''}`}
            >
                {isMobile() ? this.renderMobileView(this.props.filters && this.props.filters.type) : this.renderWebView()}

                {isMobile() ?
                    <ParticipateMobileModal
                        isModalOpen={this.props.isParticipateModalOpen}
                        closeModal={this.props.closeParticipateModal}
                        openSubmitModalRequest={(type) => this.onSubmit(type)}
                        textLiveMusic={this.props.datatypes ? this.props.datatypes.defaults.textEvent : ''}
                        textService={this.props.datatypes ? this.props.datatypes.defaults.textService : ''}
                        textMusician={this.props.datatypes ? this.props.datatypes.defaults.textMusician : ''}
                        textBand={this.props.datatypes ? this.props.datatypes.defaults.textBand : ''}
                    />
                :
                    <ParticipateModal
                        isModalOpen={this.props.isParticipateModalOpen}
                        closeModal={this.props.closeParticipateModal}
                        openSubmitModalRequest={(type) => this.onSubmit(type)}
                        textLiveMusic={this.props.datatypes ? this.props.datatypes.defaults.textEvent : ''}
                        textService={this.props.datatypes ? this.props.datatypes.defaults.textService : ''}
                        textMusician={this.props.datatypes ? this.props.datatypes.defaults.textMusician : ''}
                        textBand={this.props.datatypes ? this.props.datatypes.defaults.textBand : ''}
                    />
                }
                <SubmitModalContainer
                    isModalOpen={this.props.isSubmitModalOpen}
                    closeModal={this.props.closeSubmitModal}
                />
                <SubmitBandFinderModalContainer
                    isModalOpen={this.props.isSubmitBandFinderModalOpen}
                    closeModal={this.props.closeSubmitBandFinderModal}
                />
                <SignupModalContainer
                    isModalOpen={this.props.isSignupModalOpen}
                    closeModal={this.props.closeSignupModal}
                    changeToLogin={this.props.openLoginModal}
                />
                <LoginModalContainer />
                <TempUserLogin />
                {/*<Packages*/}
                {/*    isModalOpen={this.props.isPayingMethodsModalOpen}*/}
                {/*    closeModal={this.props.closePayingMethodsModal}*/}
                {/*    service={(this.props.newPin && this.props.newPin.type)}*/}
                {/*    pin={this.props.newPin}*/}
                {/*    datatypes={this.props.datatypes}*/}
                {/*    userPins={this.props.userPins}*/}
                {/*/>*/}

                <GeneralMessage
                    header={this.props.generalMessageHeader}
                    content={this.props.generalMessageMessage}
                    list={this.props.generalMessageList}
                    isModalOpen={this.props.isGeneralMessageModalOpen}
                    closeModal={this.props.closeGeneralMessageModal}
                    confirm={this.props.generalMessageConfirm}
                    isCancel={this.props.isCancel}
                />

                <LoadingSpinner
                    isModalOpen={this.props.isLoadingSpinnerOpen}
                />
            </div>
        )
    }
}

TopBar.propTypes = {

    // state props
    token: PropTypes.string,
    datatypes: PropTypes.object,
    newPin: PropTypes.object,
    filters: PropTypes.object,
    generalMessageHeader: PropTypes.string,
    generalMessageMessage: PropTypes.string,
    generalMessageList: PropTypes.array,
    isGeneralMessageModalOpen: PropTypes.bool,
    isLoadingSpinnerOpen: PropTypes.bool,
    isCancel: PropTypes.bool,
    isPayingMethodsModalOpen: PropTypes.bool,
    isSignupModalOpen: PropTypes.bool,
    isSubmitBandFinderModalOpen: PropTypes.bool,
    isSubmitModalOpen: PropTypes.bool,
    isParticipateModalOpen: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    isVerified: PropTypes.bool,
    mode: PropTypes.oneOf(['list', 'map', 'gallery']),
    route: PropTypes.string,

    // state functions
    getPinsCall: PropTypes.func,
    getMapPinsCall: PropTypes.func,
    userPinsCall: PropTypes.func,
    getUserData: PropTypes.func,
    clearPinList: PropTypes.func,
    generalMessageConfirm: PropTypes.func,
    closeGeneralMessageModal: PropTypes.func,
    closePayingMethodsModal: PropTypes.func,
    openLoginModal: PropTypes.func,
    closeSignupModal: PropTypes.func,
    closeSubmitBandFinderModal: PropTypes.func,
    closeSubmitModal: PropTypes.func,
    closeParticipateModal: PropTypes.func,
    closeBandFinderPinModal: PropTypes.func,
    closePinFullViewModal: PropTypes.func,
    closePinModal: PropTypes.func,
    closeLoginModal: PropTypes.func,
    openContactModal: PropTypes.func,
    toggleMode: PropTypes.func,
    openVideoModal: PropTypes.func,
    userActivation: PropTypes.func,
    serverRedirect: PropTypes.func,
    openParticipateModal: PropTypes.func,
    openSubmitModalRequest: PropTypes.func,
    openSignupModal: PropTypes.func,
    signOut: PropTypes.func,
    resetFiltersType: PropTypes.func,
    openGeneralMessageModal: PropTypes.func,
    getSharedPin: PropTypes.func,
    getPinCountCall: PropTypes.func,
    addFilter: PropTypes.func,
    updateFilters: PropTypes.func,
    toggleMobileSideMenu: PropTypes.func,
    clearCountryPinCount: PropTypes.func,
    isMapTop: PropTypes.bool,
    isMobileFilterBar: PropTypes.bool,
    userPins: PropTypes.array
}

const mapStateToProps = state => ({
    isPayingMethodsModalOpen: state.main.isPayingMethodsModalOpen,
    newPin: state.users.pinDataWaiting,
    filters: state.main.filters,
    isSignupModalOpen: state.users.isSignupModalOpen,
    isLoginModalOpen: state.users.isLoginModalOpen,
    isLoadingSpinnerOpen: state.main.isLoadingSpinnerOpen,
    isParticipateModalOpen: state.users.isParticipateModalOpen,
    isGeneralMessageModalOpen: state.main.isGeneralMessageModalOpen,
    isSubmitModalOpen: state.users.isSubmitModalOpen,
    isSubmitBandFinderModalOpen: state.users.isSubmitBandFinderModalOpen,
    isLoggedIn: state.users.isLoggedIn,
    token: state.users.token,
    isVerified: state.users.isVerified,
    datatypes: state.main.datatypes,
    mode: state.main.mode,
    route: state.routing.locationBeforeTransitions.pathname,
    generalMessageHeader: state.main.header,
    generalMessageMessage: state.main.message,
    generalMessageList: state.main.list,
    generalMessageConfirm: state.main.confirm,
    isCancel: state.main.isCancel,
    isMobileFilterBar: state.main.isMobileFilterBar,
    userPins: state.users.myPins,
});

// connecting the component to the actions in order to be able to dispatch them from the component
export const TopBarContainer = connect(mapStateToProps, {
    ...actions,
    ...userActions,
    toggleMobileSideMenu,
    setInfoMessageBar,
    closePinFullViewModal
})(TopBar);

export default TopBar;



// WEBPACK FOOTER //
// ./src/Components/Main/TopBar.js